import Immutable from "immutable";

export function createFeatureFlagsReducer(featureFlags) {
	return (state = Immutable.Map(featureFlags)) => state;
}
